module.exports = __webpack_public_path__ + "07d9d774647a3b8248063071cddb4e8b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/progressive_2022_chart.png
// module id = 1718
// module chunks = 0